/**
 * @description Presentation maps for the conversation "semáforo" (traffic light).
 * The backend calculates and exposes trafficLightStatus / analysisState / attentionStatus /
 * requiresReview. The frontend only consumes and represents; it does not recalculate anything.
 * Labels are resolved through i18n (react-i18next, namespace 'chats').
 */

// trafficLightStatus -> color
export const TRAFFIC_LIGHT_COLOR = {
  green: 'var(--secondary-300)',
  yellow: '#FACC15',
  red: '#EF4444',
  gray: '#9CA3AF'
}

export const DEFAULT_TRAFFIC_LIGHT = 'gray'
export const DEFAULT_ATTENTION_STATUS = 'not_required'

const VALID_ATTENTION_STATUS = ['attended', 'not_attended', 'not_required']

/**
 * @description Returns a safe trafficLightStatus, falling back to gray when missing/unknown.
 * @param {string} status raw conv.trafficLightStatus
 * @return {string}
 */
export const getTrafficLightStatus = (status) =>
  TRAFFIC_LIGHT_COLOR[status] ? status : DEFAULT_TRAFFIC_LIGHT

/**
 * @description Returns a safe attentionStatus, falling back to not_required when missing/unknown.
 * @param {string} attentionStatus raw conv.attentionStatus
 * @return {string}
 */
export const getAttentionStatus = (attentionStatus) =>
  VALID_ATTENTION_STATUS.includes(attentionStatus) ? attentionStatus : DEFAULT_ATTENTION_STATUS

/**
 * @description Builds the tooltip / aria-label text: "{semáforo} · {atención}" using i18n.
 * @param {Function} t react-i18next translator bound to the 'chats' namespace
 * @param {string} status raw conv.trafficLightStatus
 * @param {string} attentionStatus raw conv.attentionStatus
 * @return {string}
 */
export const getTrafficLightTooltip = (t, status, attentionStatus) => {
  const safeStatus = getTrafficLightStatus(status)
  const safeAttention = getAttentionStatus(attentionStatus)
  return `${t(`trafficLight.${safeStatus}`)} · ${t(`attention.${safeAttention}`)}`
}
